import React from "react"
import { useSelector } from "react-redux"
import NotAuthorized from "components/Common/ModuleNotAuth"

const ProtectedRoute = ({ component: Component, modulePath }) => {
  const allowedModules = useSelector(state => state.Login.allowedModules || [])

  const isModuleBlocked = modulePath
    ? allowedModules.some(mod => mod.module_app_url === modulePath)
    : false;

  if (isModuleBlocked) {
    return <NotAuthorized />
  }

  return <Component />
}

export default ProtectedRoute
